import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fund-list-icons',
  templateUrl: './fund-list-icons.component.html',
  styleUrls: ['./fund-list-icons.component.scss'],
  standalone: false
})
export class FundListIconsComponent {
  @Input() currentAccountType: string;
}
